import i18n from '@/main';
import http from '@/utils/http';
import axios from 'axios';

const URL_BASE = '/contrato-originacao/subempresa';

export default {
    buscarDetalheAnalise(numeroContrato, idTerritorio) {
        return http.get({
            url:
                URL_BASE +
                '/detalhe-analise/' +
                numeroContrato +
                '/' +
                idTerritorio,
            lockScreen: true
        });
    },

    cadastrarTerritoriosViaPlanilha(planilha, numeroContrato) {
        const url = `${process.env.VUE_APP_HTTP_PATH}${URL_BASE}/inserir-planilha/${numeroContrato}`;

        const formData = new FormData();
        formData.append('planilha', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    dadosContratoSubempresa(numeroContrato) {
        return http.get({
            url: URL_BASE + '/dados-gerais/' + numeroContrato,
            lockScreen: false,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDadosGeraisDeContratos'
            )
        });
    },

    contratosNaoEnviadosSucursais({ page = 0, search = '', order = 'ASC' }) {
        return http.get({
            url:
                URL_BASE +
                `/nao-enviados?page=${page}&search=${search}&order=${order}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDadosGeraisDeContratos'
            )
        });
    },

    dadosContratoSubempresaPY(numeroContrato) {
        return http.get({
            url: URL_BASE + '/dados-gerais/PY/' + numeroContrato,
            lockScreen: false,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDadosGeraisDeContratos'
            )
        });
    },

    inserirDadosContrato(body) {
        const url = process.env.VUE_APP_HTTP_PATH + URL_BASE + '/inserir';
        return axios.post(url, body, {
            lockScreen: false,
            lockMessage: 'Salvando dados de contrato',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },

    inserirDadosContratoPY(body) {
        const url = process.env.VUE_APP_HTTP_PATH + URL_BASE + '/inserirPY';
        return axios.post(url, body, {
            lockScreen: false,
            lockMessage: '...',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },

    inserirDadosContratoAR(body) {
        const url = process.env.VUE_APP_HTTP_PATH + URL_BASE + '/inserirAR';
        return axios.post(url, body, {
            lockScreen: false,
            lockMessage: '...',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },

    buscarVisualizarProcessamentoSubEmpresa({ numeroContrato }) {
        return http.get({
            url: URL_BASE + `/visualizar/${numeroContrato}`,
            lockScreen: true
        });
    },

    buscarVisualizarProcessamentoSubEmpresaPY({ numeroContrato }) {
        return http.get({
            url: URL_BASE + `/visualizar/PY/${numeroContrato}`,
            lockScreen: true
        });
    },

    buscarVisualizarProcessamentoSubEmpresaAR({ numeroContrato }) {
        return http.get({
            url: URL_BASE + `/visualizar/AR/${numeroContrato}`,
            lockScreen: true
        });
    },

    buscarTerritoriosVisualizarProcessamentoContratoSubEmpresa({
        contrato,
        pagina,
        tamanho
    }) {
        return http.get({
            url: URL_BASE + `/${contrato}?page=${pagina}&size=${tamanho}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    buscarTerritoriosVisualizarProcessamentoContratoSubEmpresaPY({
        contrato,
        pagina,
        tamanho
    }) {
        return http.get({
            url: URL_BASE + `/PY/${contrato}?page=${pagina}&size=${tamanho}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    buscarDadosContratosOriginacao({
        numeroContrato,
        page,
        size,
        territoriosComRestricoes
    }) {
        return http.get({
            url:
                URL_BASE +
                `/${numeroContrato}?page=${page}&size=${size}&territoriosComRestricoes=${territoriosComRestricoes}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeContrato')
        });
    },

    removerTerritorioContratoSubEmpresa(
        numeroContrato,
        idTerritorio,
        codigoCar
    ) {
        return http.post({
            url:
                URL_BASE +
                `/remover/${numeroContrato}/${idTerritorio}/${codigoCar}`,
            data: {},
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoTerritorio')
        });
    },

    removerTerritorioContratoSubEmpresaPY(numeroContrato, idTerritorio) {
        return http.post({
            url: URL_BASE + `/remover-py/${numeroContrato}/${idTerritorio}`,
            data: {},
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoTerritorio')
        });
    },

    concluirProcessamentoContratoSubempresa({ contrato }) {
        return http.get({
            url: URL_BASE + `/concluir-processamento/${contrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.concluindoProcessamento')
        });
    },

    concluirProcessamentoContratoSubempresaPY({ contrato }) {
        return http.get({
            url: URL_BASE + `/concluir-processamento-py/${contrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.concluindoProcessamento')
        });
    },

    concluirProcessamentoContratoSubempresaAR({ contrato }) {
        return http.get({
            url: URL_BASE + `/concluir-processamento-ar/${contrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.concluindoProcessamento')
        });
    },

    exportarRelatorioContratoSubempresa(numeroContrato, listarTerritorios) {
        return http.get({
            url:
                URL_BASE +
                `/exportar-relatorio/${numeroContrato}?listarTerritorios=${listarTerritorios}`,
            lockScreen: false
        });
    },

    verificaConcluir(numeroContrato) {
        return http.get({
            url: URL_BASE + '/verifica-concluir/' + numeroContrato,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.verificandoSeOContratoPodeSerConcluido'
            )
        });
    },

    verificaConcluirPY(numeroContrato) {
        return http.get({
            url: URL_BASE + '/verifica-concluir-py/' + numeroContrato,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.verificandoSeOContratoPodeSerConcluido'
            )
        });
    },

    verificaConcluirAR(numeroContrato) {
        return http.get({
            url: URL_BASE + '/verifica-concluir-ar/' + numeroContrato,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.verificandoSeOContratoPodeSerConcluido'
            )
        });
    },

    inserirTerritorio(data) {
        return http.post({
            url: URL_BASE + `/territorio/inserir`,
            data: data,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.inserindoTerritorio')
        });
    },

    enviarContratosSucursais(data) {
        return http.post({
            url: URL_BASE + `/enviar-contratos-sucursales`,
            data: data,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.inserindoTerritorio')
        });
    },

    buscarDadosLoteSubEmpresa(numeroContrato) {
        return http.get({
            url: `${URL_BASE}/lote/${numeroContrato}`,
            lockScreen: false
        });
    },

    downloadPlanilhaComErroSubEmpresa(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: URL_BASE + `/lote/download-planilha-erro/${id}`,
                    responseType: 'blob',
                    lockScreen: false
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    totalizadores(body) {
        return http.post({
            url: `${URL_BASE}/totalizadores`,
            data: body,
            lockScreen: false
        });
    },
    totalizadoresPY(body) {
        return http.post({
            url: `${URL_BASE}/totalizadoresPY`,
            data: body,
            lockScreen: false
        });
    },
    totalizadoresAR(body) {
        return http.post({
            url: `${URL_BASE}/totalizadoresAR`,
            data: body,
            lockScreen: false
        });
    },
    statusSubEmpresa() {
        return http.get({
            url: URL_BASE + '/status',
            lockScreen: false
        });
    },
    contratos(dados, params) {
        return http.post({
            url:
                URL_BASE +
                `?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen: false
        });
    },
    contratosPY(dados, params) {
        return http.post({
            url: `${URL_BASE}PY?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen: false
        });
    },
    contratosAR(dados, params) {
        return http.post({
            url: `${URL_BASE}AR?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen: false
        });
    },
    buscarTerritorioFiltro(search) {
        return http.post({
            url: URL_BASE + `/territorio/filtro`,
            data: {
                filtro: search
            },
            lockScreen: false
        });
    },

    buscarTerritorioFiltroPY(search) {
        return http.post({
            url: URL_BASE + `/territorio/filtroPY`,
            data: {
                fincaOuPadronOuNome: search
            },
            lockScreen: false
        });
    },

    buscarTotalizadoresUnicoContratoSubEmpresa({ contrato }) {
        return http.get({
            url: URL_BASE + `/totalizador/unico-contrato/${contrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    inserirCodigoExterno(data) {
        return http.put({
            url: URL_BASE + `/codigo-externo/inserir`,
            data: data,
            lockScreen: false
        });
    },

    solicitarAnaliseTerritorioInconformeEmpresa({
        numeroContrato,
        idTerritorio,
        codigoCar
    }) {
        return http.post({
            url: URL_BASE + `/territorio/analise-inconforme`,
            data: {
                numeroContrato,
                idTerritorio,
                codigoCar
            },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.solicitandoAnaliseDoTerritorioInconforme'
            )
        });
    },

    validarTerritorioContrato(data) {
        return http.post({
            url: URL_BASE + '/validar',
            data: data,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.validandoDadosDoTerritorio')
        });
    },

    realizarDiagnosticoSocioambientalPreInsercaoTerritorio(
        data,
        lockScreen = false
    ) {
        return http.post({
            url: URL_BASE + '/diagnostico-socioambiental/pre-insercao-contrato',
            data: data,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },

    buscarResumoAnaliseElegibilidadePreInsercaoTerritorio({
        codigoCar,
        cpfCnpj,
        numeroContrato,
        idTerritorio
    }) {
        return http.get({
            url:
                URL_BASE +
                `/territorio/buscar-resumo-analise-elegibilidade?codigoCar=${codigoCar}${
                    cpfCnpj ? `&cpfCnpj=${cpfCnpj}` : ''
                }&numeroContrato=${numeroContrato}&idTerritorio=${idTerritorio}`,
            lockScreen: false
        });
    },

    buscarTerritoriosPreencherContrato({ contrato, pagina, tamanho }) {
        return http.get({
            url: URL_BASE + `/${contrato}?page=${pagina}&size=${tamanho}`,
            lockScreen: false,
            lockMessage: 'Buscando territórios'
        });
    },

    buscarTerritoriosPreencherContratoPY({ contrato, pagina, tamanho }) {
        return http.get({
            url: URL_BASE + `/PY/${contrato}?page=${pagina}&size=${tamanho}`,
            lockScreen: false,
            lockMessage: 'Buscando territórios'
        });
    },

    buscarTerritoriosPreencherContratoAR({ contrato, pagina, tamanho }) {
        return http.get({
            url: URL_BASE + `/AR/${contrato}?page=${pagina}&size=${tamanho}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    buscarSaldo(data, lockScreen = false) {
        return http.get({
            url: URL_BASE + '/territorio/busca-saldo-car',
            data: data,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },

    aceitarTermo(numeroContrato) {
        return http.put({
            url: URL_BASE + `/aceitar-termo-declaracao-py/${numeroContrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.termoDeclacarao')
        });
    },

    buscarSaldoAr(idTerritorio, numeroContrato) {
        return http.get({
            url:
                URL_BASE +
                `/territorio/busca-saldo-ar?idTerritorio=${idTerritorio}&numeroContrato=${numeroContrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },

    solicitarLaudoElegibilidade(idTerritorio, numeroContrato, codigoCar, file) {
        const url =
            process.env.VUE_APP_HTTP_PATH +
            URL_BASE +
            '/territorio/laudo/laudo-elegibilidade';

        const formData = new FormData();
        formData.append('idTerritorio', idTerritorio);
        formData.append('numeroContrato', numeroContrato);
        formData.append('codigoCar', codigoCar);
        formData.append('file', file?.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    buscaProdutividadeCar(
        codigoCar,
        codigoCultura,
        anoSafra,
        numeroContrato,
        lockScreen = false
    ) {
        return http.get({
            url:
                URL_BASE +
                `/territorio/car/produtividade/${codigoCar}?codigoCultura=${codigoCultura}&anoSafra=${anoSafra}&numeroContrato=${numeroContrato}`,
            lockScreen
        });
    },

    realizarAnaliseElegibilidade(body) {
        const url =
            process.env.VUE_APP_HTTP_PATH +
            URL_BASE +
            '/territorio/analisar-elegibilidade';
        return axios.post(url, body, {
            lockScreen: false,
            lockMessage: 'Realizando análise de elegibilidade dos territórios',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },

    buscarHeaderPlanilhaUpload(planilha) {
        const url = `${process.env.VUE_APP_HTTP_PATH}${URL_BASE}/processa-cabecalho-planilha`;

        const formData = new FormData();
        formData.append('planilha', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    validarPlanilhaTerritorio(cabecalhoMapeado, planilha, tipoContrato) {
        const url = `${process.env.VUE_APP_HTTP_PATH}${URL_BASE}/valida-planilha-territorio`;

        const formData = new FormData();

        for (const key in cabecalhoMapeado) {
            formData.append(`${cabecalhoMapeado[key]}`, key);
        }
        formData.append('planilha', planilha.raw);
        formData.append('tipoContrato', tipoContrato);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    realizarElegibilidadeLote(numeroContrato, territorios) {
        return http.post({
            url: URL_BASE + '/territorio/lote/analisa-elegibilidade',
            data: {
                numeroContrato,
                territorios
            },
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },
    rastreabilidadeInserirLote(numeroContrato, cars) {
        return http.post({
            url: URL_BASE + `/${numeroContrato}/inserir-lote`,
            data: {
                cars
            },
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },
    getFornecedoresOfflineSubEmpresa() {
        return http.get({
            url: URL_BASE + '/fornecedores-contrato-offline',
            lockScreen: false,
            lockMessage: 'Buscando informações'
        });
    },
    buscarResumoAnaliseElegibilidadePreInsercaoTerritorioPy({
        idRepresentante,
        numeroContrato,
        idTerritorio
    }) {
        return http.get({
            url:
                URL_BASE +
                `/territorio/buscar-resumo-elegibilidade-py?idRepresentante=${idRepresentante}&numeroContrato=${numeroContrato}&idTerritorio=${idTerritorio}`,
            lockScreen: false
        });
    },
    buscarResumoAnaliseElegibilidadePreInsercaoTerritorioAr({
        idRepresentante,
        numeroContrato,
        idTerritorio
    }) {
        return http.get({
            url:
                URL_BASE +
                `/territorio/buscar-resumo-elegibilidade-ar?idRepresentante=${idRepresentante}&numeroContrato=${numeroContrato}&idTerritorio=${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.analiseElegibilidade')
        });
    },
    buscarPorTipoContrato(filtro) {
        return http.post({
            url: URL_BASE + `/subempresa/dados-gerais/${filtro}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },
    realizarAnaliseElegibilidadePY(body) {
        const url =
            process.env.VUE_APP_HTTP_PATH +
            URL_BASE +
            '/territorio/analisar-elegibilidade-py';
        return axios.post(url, body, {
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes'),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    realizarAnaliseElegibilidadeAR(body) {
        const url =
            process.env.VUE_APP_HTTP_PATH +
            URL_BASE +
            '/territorio/analisar-elegibilidade-ar';
        return axios.post(url, body, {
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes'),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },

    downloadTermoDeclaracaoJuradaSubempresa(numeroContrato) {
        return http.get({
            url: URL_BASE + `/download-termo-declaracao-py/${numeroContrato}`,
            lockScreen: false,
            responseType: 'blob'
        });
    }
};
